import { render, staticRenderFns } from "./tencent-video-viewer.vue?vue&type=template&id=ac3d32da&"
import script from "./tencent-video-viewer.vue?vue&type=script&lang=js&"
export * from "./tencent-video-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports